import React from 'react';
import { mdiShareVariant, mdiMenuRight, mdiLink, mdiEmail, mdiTwitter, mdiFacebook, mdiInstagram } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { usePopover } from '../../hooks/usePopover';
import { IconSize } from '../../lib';
import { copyUrlToClipboard } from '../../utils/copyUrlToClipboard';
import { TooltippedIconButton } from '../Buttons';
import { StyledListItem, StyledMenu } from './index.styles';
const StyledIcon = styled(Icon) `
    margin-left: auto;
    margin-right: 0 !important;
`;
export const ShareMenu = ({ variant = 'listItem', closeParent, onClipboardClick = copyUrlToClipboard, onEmailClick, onTweetClick, onFacebookClick, onInstagramClick }) => {
    const { open, anchorEl, handlePopoverClick, handlePopoverClose } = usePopover();
    return (React.createElement(React.Fragment, null,
        variant === 'button' ? (React.createElement(TooltippedIconButton, { title: "Share", icon: React.createElement(Icon, { path: mdiShareVariant }), onClick: handlePopoverClick })) : (React.createElement(StyledListItem, { button: true, onClick: (e) => {
                e.stopPropagation();
                handlePopoverClick(e);
            } },
            React.createElement(Icon, { path: mdiShareVariant }),
            " Share ",
            React.createElement(StyledIcon, { path: mdiMenuRight, size: IconSize.Medium }))),
        React.createElement(StyledMenu, { getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
            }, anchorEl: anchorEl, open: open, onClose: handlePopoverClose, onClick: (e) => {
                e.stopPropagation();
                handlePopoverClose();
                if (closeParent) {
                    closeParent();
                }
            } },
            React.createElement(StyledListItem, { button: true, onClick: onClipboardClick, disabled: !onClipboardClick },
                React.createElement(Icon, { path: mdiLink }),
                " Copy link to clipboard"),
            React.createElement(StyledListItem, { button: true, onClick: onEmailClick, disabled: !onEmailClick },
                React.createElement(Icon, { path: mdiEmail }),
                " Compose email"),
            React.createElement(StyledListItem, { button: true, onClick: onTweetClick, disabled: !onTweetClick },
                React.createElement(Icon, { path: mdiTwitter }),
                " Tweet this"),
            React.createElement(StyledListItem, { button: true, onClick: onFacebookClick, disabled: !onFacebookClick },
                React.createElement(Icon, { path: mdiFacebook }),
                " Post to Facebook"),
            React.createElement(StyledListItem, { button: true, onClick: onInstagramClick, disabled: !onInstagramClick },
                React.createElement(Icon, { path: mdiInstagram }),
                " Share on Instagram"))));
};
//# sourceMappingURL=ShareMenu.js.map